// export const stagingServer = 'https://api.staging.cosimo.skunktest.work/api/v2/';
export const stagingServer = 'https://api.dev.latest.cosimo.skunktest.work/api/';
export const preProdServer = 'https://api.pre-release.cosimo.skunktest.work/api/';
export const ProdServer = 'https://api.cosimo.art/api/';
